import _ from 'lodash';
import { ClientEntity } from '../../../../../common/types/EntityTypes';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  removeFilterFromDB,
  selectClients,
  selectInboxId,
  setClients,
  updateUserFilterName,
} from '../../../../../redux/reducers/metadataSlice';
import {
  selectMenuTriggor,
  setShowFilterDeletePopup,
} from '../../../../../redux/reducers/popupSlice';
import './TabModal.scss';
import { selectCurrentTab, setSelectedTab } from '../../../../../redux/reducers/dashboardSlice';
import {
  selectSelectedTabFilterInfo,
  setFilterDialogState,
  setSelectedTabFilterInfo,
} from '../../../../../redux/reducers/tabFilterSlice';
import { FILTER_SETTINGS_STATE } from '../../../../../common/constants';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
function TabNameDialog() {
  const dispatch = useAppDispatch();
  const tabActionTriggor = useAppSelector(selectMenuTriggor);
  const clients: ClientEntity[] = useAppSelector(selectClients);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const currentTabId = useAppSelector(selectCurrentTab);
  const tabFilterInfo = useAppSelector(selectSelectedTabFilterInfo);
  const [updatedFilterName, setUpdatedFilterName] = useState(tabFilterInfo.name);
  const [isTabNameDirty, setIsTabNameDirty] = useState(false);
  const [filterNameError, setFilterNameError] = useState('');
  const inboxId = useAppSelector(selectInboxId);

  const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setUpdatedFilterName(newValue);
    setFilterNameError('');
    if(newValue === '') setFilterNameError('Filter name cannot be empty');
    if (!isTabNameDirty) setIsTabNameDirty(true);
  };

  function handleTabNameSave() {
    const tabNameDuplicates = clients.filter(
      (e) => e.name === updatedFilterName && updatedFilterName !== tabFilterInfo.name,
    );
    if (tabNameDuplicates.length > 0) {
      setFilterNameError('Filter Name already exists');
      return;
    } else {
      setFilterNameError('');
    }
    dispatch(updateUserFilterName({ ...tabFilterInfo, name: updatedFilterName })).then((e) => {
      if (e.payload) {
        dispatch(
          setSelectedTabFilterInfo({
            ...tabFilterInfo,
            name: updatedFilterName,
          }),
        );
        dispatch(setFilterDialogState(FILTER_SETTINGS_STATE.FILTER_SETTINGS));
      }
    });
  }

  function handleCancel() {
    dispatch(removeFilterFromDB(tabFilterInfo.id)).then((resp) => {
      dispatch(setFilterDialogState(''));
      dispatch(setSelectedTabFilterInfo({}));
      if (currentTabId === tabFilterInfo.id) {
        dispatch(setSelectedTab(inboxId));
      }
    });
  }

  useEffect(() => {
    inputRef.current?.select();
  }, []);

  return (
    <section className='rename-dialog-container'>
      <div className='rdc-warning-text'>Enter a new Filter name</div>
      <div>
        <input
          className='rdc-filter-name-input'
          ref={inputRef}
          onChange={(event) => handleChange(event)}
          type='text'
          autoFocus
          maxLength={20}
          value={updatedFilterName}
        />
      </div>
     <div className='rdc-error-message'>
        {filterNameError && <span>{filterNameError}</span>}
      </div>
      <div className='rdc-footer'>
        <button className='rdc-button' onClick={handleCancel}>
          <span className='rdc-button-text'>Cancel</span>
        </button>
        <button className={classNames('rdc-button rdc-button-yellow', {
          'rdc-btn-disabled': updatedFilterName === ''
        })} disabled={updatedFilterName === ''} onClick={handleTabNameSave}>
          <span className='rdc-button-text'>Ok</span>
        </button>
      </div>
    </section>
  );
}
export default TabNameDialog;
